import React, { Fragment } from 'react';

export const Conditional = ({ children, condition }) => condition ? <Fragment>{ children }</Fragment> : null;
